import { render, staticRenderFns } from "./DiNapoli.vue?vue&type=template&id=4d4170ec&scoped=true"
import script from "./DiNapoli.vue?vue&type=script&lang=js"
export * from "./DiNapoli.vue?vue&type=script&lang=js"
import style0 from "./DiNapoli.vue?vue&type=style&index=0&id=4d4170ec&prod&lang=css"
import style1 from "./DiNapoli.vue?vue&type=style&index=1&id=4d4170ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4170ec",
  null
  
)

export default component.exports